import { Stack } from "@chakra-ui/react";
import {
  EventDetailPixelsSection,
  KYDPixelSettingsUpdate,
} from "@common/interfaces/KYDEvent";
import { useCallback } from "react";
import actions from "../../../../actions";
import { useDialog } from "../../../../Common/Dialog";
import MarketingPixelsEditor from "../../../MarketingPixelsEditor";
import EventDetailTitle from "../../../EventDetailTitle";
import { SectionProps } from "../../sections/sectionsComponents";

const PixelsSection = ({
  data,
  isLoading,
  permissions,
  refetchEvent,
}: SectionProps<EventDetailPixelsSection["data"]>) => {
  const dialog = useDialog();
  const readOnly = !permissions.includes("write");

  const savePixels = useCallback(
    async (pixels: KYDPixelSettingsUpdate[]) => {
      try {
        await actions.ADMIN.updateEventPixels({
          event_id: data.id,
          pixels,
        });
        await refetchEvent({ silent: true });
      } catch (error) {
        dialog({
          title: "Error",
          text: error.message,
        });
        throw error;
      }
    },
    [data.id, dialog, refetchEvent]
  );

  return (
    <Stack>
      <EventDetailTitle>Event Pixels</EventDetailTitle>
      <MarketingPixelsEditor
        isLoading={isLoading}
        onSave={savePixels}
        pixels={data.marketing_pixels || []}
        readOnlyPixels={data.organization_marketing_pixels || []}
        readOnly={readOnly}
      />
    </Stack>
  );
};

export default PixelsSection;
